import type { Complex } from "../math/complex";
import { fourierConfig as config } from "../config";

type Props = {
  path: string;
  tip?: Complex;
  opacity?: number;
  tipOpacity?: number;
  glow?: number;
  scale?: number;
  colors?: { trail: string; background: string };
  trailWidth?: number;
};
export const FourierTrail = ({
  path,
  tip,
  opacity = 1,
  tipOpacity = 1,
  glow = 0.28,
  scale = config.layout.scale,
  colors = config.colors,
  trailWidth = config.trailWidth,
}: Props) => {
  return (
    <g
      opacity={opacity}
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
    >
      {glow > 0 && <path
        d={path}
        stroke={colors.trail}
        strokeWidth={14 / scale}
        opacity={glow}
        filter="url(#trail-glow)"
      />}
      <path
        d={path}
        stroke={colors.trail}
        strokeWidth={trailWidth / scale}
      />
      {tip && (
        <g opacity={tipOpacity}>
          {glow > 0 && <circle
            cx={tip.x}
            cy={tip.y}
            r={15 / scale}
            fill={colors.trail}
            opacity={0.55}
            filter="url(#tip-glow)"
          />}
          <circle cx={tip.x} cy={tip.y} r={5.8 / scale} fill={colors === config.colors ? "#FFF2FA" : colors.trail} />
          <circle cx={tip.x} cy={tip.y} r={2.5 / scale} fill={colors === config.colors ? "white" : colors.background} />
        </g>
      )}
    </g>
  );
};
